export default {
    namespaced: 'true',
    state: {
        additionalQuestions: {},
        allegations: [],
        allegationsChecklistOptions: [],
        complainant: {},
        complaint: {},
        complaintSubmissionLangOptions: [],
        complaintSubmissionRoleOptions: [],
        counties: [],
        documents: [],
        docUploadFileTypes: [
            '3gp',
            'csv',
            'doc',
            'docx',
            'gif',
            'jpeg',
            'jpg',
            'json',
            'mov',
            'mp3',
            'mp4',
            'pdf',
            'png',
            'ppt',
            'txt',
            'wmv',
            'xls',
            'xlsx',
            'xml',
        ],
        docUploadTypes: [],
        isInitialized: false,
        isLoading: true,
        respondent: {},
        text: {
            additionalQuestionsDateEndComplaintLabel: '',
            additionalQuestionsDateEndWorkHelperText: '',
            additionalQuestionsDateEndWorkLabel: '',
            additionalQuestionsDateRangeComplaintLabel: '',
            additionalQuestionsDateStartComplaintLabel: '',
            additionalQuestionsDateStartWorkLabel: '',
            additionalQuestionsDescribeTextLabel: '',
            additionalQuestionsHeading: '',
            allegationsChecklistLabel: '',
            allegationsHeading: '',
            complaintSubmissionAddressLabel: '',
            complaintSubmissionEmailLabel: '',
            complaintSubmissionFirstNameLabel: '',
            complaintSubmissionHeading: '',
            complaintSubmissionLangLabel: '',
            complaintSubmissionLastNameLabel: '',
            complaintSubmissionPhoneLabel: '',
            complaintSubmissionRoleLabel: '',
            complaintSubmissionRoleRetaliationNotice: '',
            complaintSubmissionSubmitButtonLabel: '',
            complaintSubmissionSubmitErrorHeading: '',
            complaintSubmissionSubmitErrorText: '',
            confirmationContact: '',
            confirmationNextSteps: '',
            confirmationNextOptions: '',
            confirmationText: '',
            contactEmailLabel: '',
            contactHeading: '',
            contactFirstNameLabel: '',
            contactLastNameLabel: '',
            contactPhoneLabel: '',
            docUploadHeading: '',
            employerAddressLabel: '',
            employerEmailLabel: '',
            employerHeading: '',
            employerNameLabel: '',
            employerPhoneLabel: '',
            formTitle: '',
            retaliationMessage: '',
            retaliationRoleMessage: '',
        },
    },
    getters: {
        isAnonymous: state => state.complainant?.role === 'anon' || false,
        isInitialized: state => state.isInitialized,
        isLoading: state => state.isLoading,
        text: state => state.text,
    },
    mutations: {
        SET_VALUE(state, payload) {
            state[payload.key] = payload.value;
        },
    },
};